import GTMEvent from "./event";

type Dependency = () => boolean;
class GTMEvents {
    private static dependencies: Dependency[] = [];
    public static processing = false;
    public static queue: GTMEvent[] = [];
    public static successful: GTMEvent[] = [];

    // Check if the script(s) have been loaded and if all dependencies are true
    private static checkDependencies = () => GTMEvents.dependencies.every((dependency) => dependency());

    // Check if we not done loading all scripts and dependencies
    // OR if we have already have a queue?
    private static shouldBeQueued = () => !GTMEvents.checkDependencies() || GTMEvents.queue.length > 0;

    private static processEvent = (event: GTMEvent) => {
        if (!event.track()) {
            // Only for debugging
            GTMEvents.successful.push(event);
        }
    };

    public static addDependency = (dependency: Dependency) => {
        GTMEvents.dependencies.push(dependency);
    };
    public static processQueue = () => {
        if (GTMEvents.processing || !GTMEvents.checkDependencies()) {
            return false;
        }
        GTMEvents.processing = true;
        while (GTMEvents.queue.length) {
            const event = GTMEvents.queue.shift() as GTMEvent;
            GTMEvents.processEvent(event);
        }
        GTMEvents.processing = false;
        return true;
    };
    public static addEvent = (event: GTMEvent) => {
        if (GTMEvents.shouldBeQueued()) {
            GTMEvents.queue.push(event);
        } else {
            GTMEvents.processEvent(event);
        }
    };

    public static debug = () => {
        return {
            processing: GTMEvents.processing,
            dependencies: GTMEvents.dependencies,
            dependencyCheck: GTMEvents.checkDependencies(),
            queue: GTMEvents.queue,
            successful: GTMEvents.successful,
        };
    };
}

export default GTMEvents;
